import type { TransactionData } from 'pages/Transactions/types';
import type { Paths } from 'apps/shared/data-access/types/routing.types';
import type { HomePageWidgetItem } from 'apps/core/types/home-page-widgets/home-page-widgets.types';
import type { DeepPartial, Nullable } from 'apps/core/types/global.types';
import type { IINEntity } from 'apps/admin/iin/data-access/types/iin.types';
import type { UserAccountsTableRowData } from 'apps/user-accounts/data-access/types/user-accounts.types';

export enum WebStorageKeys {
  PAYMENTIQ_GENERAL_SETTINGS = 'PAYMENTIQ_GENERAL_SETTINGS',
  PAYMENTIQ = 'PaymentIQ',
  TRANSACTIONS_VIEW_FILTER_OPTIONS = 'TRANSACTIONS_VIEW_FILTER_OPTIONS',
  IIN_VIEW_FILTER_OPTIONS = 'IIN_VIEW_FILTER_OPTIONS',
  TRANSACTIONS_VIEW_FAVORITE_FILTERS = 'TRANSACTIONS_VIEW_FAVORITE_FILTERS',
  RULESETS_WORKFLOW_ALL_RULESETS_FILTERS = 'RULESETS_WORKFLOW_ALL_RULESETS_FILTERS',
  RULESETS_WORKFLOW_ALL_RULESETS_COLUMNS_VISIBILITY = 'RULESETS_WORKFLOW_ALL_RULESETS_COLUMNS_VISIBILITY',
  USER_DATA = 'USER_DATA',
  DEFAULT_STORAGE = 'DEFAULT_STORAGE',
  USER_ACCOUNTS_VIEW_FILTER_OPTIONS = 'USER_ACCOUNTS_VIEW_FILTER_OPTIONS',
  APPROVE_VIEW_FILTER_OPTIONS = 'APPROVE_VIEW_FILTER_OPTIONS',
}

// if more properties are added - make these optional to allow
// partial updated. For example when changing merchantId, you can send in an object
// that only contains merchantId and not the other properties
export type PaymentIQGeneralSettings = {
  merchantId?: number;
};

type OnSort<T> = {
  sortCol: {
    id: keyof T;
    field: keyof T;
  };
  sortAsc: boolean;
};

export type TableColumnsPreference<T> = Partial<{
  [key in keyof T]: TableColumnPreference<T>;
}>;

export type TableColumnPreference<T> = {
  id: keyof T;
  visible?: boolean;
  width?: number;
  index?: number;
};

export type PagePreferences = Partial<{
  transaction: PagePreference<TransactionData>;
  iin: PagePreference<IINEntity>;
  'user-psp-accounts': PagePreference<UserAccountsTableRowData>;
}>;

type PagePreference<T> = Partial<{
  onSort: Nullable<OnSort<T>>;
  columns: TableColumnsPreference<T>;
}>;

type AppPreferences = DeepPartial<{
  merchant: {
    selected: number;
  };
  backofficeHomepage: Paths;
  sidebar: string;
  showAiChatbot: boolean;
  restoreDefaultWidgetsLayout: boolean;
  decisiontable: {
    hideDisabledRules: boolean;
  };
}>;

export type PaymentIQPreferences = Partial<{
  settings: AppPreferences;
  grid: PagePreferences;
  homePageLayout: HomePageWidgetItem[];
  isGeneralHealthHidden: boolean;
}>;
